type Elements = {
  buttons: HTMLAnchorElement[]
};

type Questions = {
  elements: Elements;
  init: () => void;
  handleClick: (e: MouseEvent | KeyboardEvent, button: HTMLAnchorElement) => void;
};

const questions: Questions = {
  elements: {
    buttons: [],
  },

  init() {
    this.elements.buttons = Array.from(document.querySelectorAll('.answer__button [data-reveal]'));

    if (this.elements.buttons.length) {
      this.elements.buttons.forEach(button => button.addEventListener('click', (e) => this.handleClick(e, button)));
    }
  },

  handleClick: (e: MouseEvent | KeyboardEvent, button: HTMLAnchorElement) => {
    e.preventDefault();

    const answer = document.querySelector(`#${button.dataset.reveal}`);

    if (answer) {
      answer.classList.toggle('reveal');

      if (answer.classList.contains('reveal')) {
        answer.setAttribute('aria-expanded', 'true');
        button.innerHTML = 'Hide Correct Answer <i class="fa-solid fa-caret-up"></i>';
      } else {
        answer.setAttribute('aria-expanded', 'false');
        button.innerHTML = 'Show Correct Answer <i class="fa-solid fa-caret-down"></i>';
      }
    }
  },
};

export default questions;
